import PencilIcon from '@/icons/pencil.svg?react';
import { useTranslation } from 'react-i18next';
import MiniLoader from './MiniLoader/MiniLoader';
import Button from './Button';
import { PropsWithChildren } from 'react';

interface Props {
  isEditing: boolean;
  title: string;
  onClickEdit: () => void;
  onClickUpdate: () => void;
  onClickCancel: () => void;
  isLoading: boolean;
  hasCustomAccountNumbers: boolean;
  className?: string;
}

export const COATabHeader = ({
  isEditing,
  title,
  onClickEdit,
  onClickUpdate,
  onClickCancel,
  isLoading,
  hasCustomAccountNumbers,
  className = '',
  children,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  return (
    <div
      className={`mb-6 flex items-center justify-between gap-x-4 ${className}`}
    >
      <div>
        <div className='text-h3 font-black' data-testid='COATabHeader-title'>
          {t(title)}
        </div>
        {children}
      </div>
      {isEditing ? (
        <div className='flex items-center gap-x-2'>
          <div>
            <Button
              styling='outline'
              onClick={onClickCancel}
              disabled={isLoading}
              data-testid='cancel-btn'
            >
              {t('Cancel')}
            </Button>
          </div>
          <div>
            <Button
              className='flex items-center'
              disabled={isLoading}
              data-testid='update-btn'
              onClick={onClickUpdate}
            >
              {isLoading && <MiniLoader className='mr-2' color='gray' />}
              <span>{t('Update')}</span>
            </Button>
          </div>
        </div>
      ) : (
        <div className='shrink-0'>
          <Button
            data-testid='edit-accounts-btn'
            styling={hasCustomAccountNumbers ? 'outline' : undefined}
            className='flex items-center gap-x-2'
            onClick={onClickEdit}
          >
            <PencilIcon
              className={
                hasCustomAccountNumbers ? undefined : '[&>g>path]:fill-white'
              }
            />
            <span>{t('Edit accounts')}</span>
          </Button>
        </div>
      )}
    </div>
  );
};
